import { render, staticRenderFns } from "./IFrameForm.vue?vue&type=template&id=9b031be0&"
import script from "./IFrameForm.vue?vue&type=script&lang=js&"
export * from "./IFrameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports